import {
    BENEFICIARY_SIGNER_ID,
    beneficiaryAge, beneficiaryShouldSign,
    DR_SIGNER_ID, GUARDIAN_SIGNER_ID,
    JOINT_SUBSCRIBER_SIGNER_ID,
    SUBSCRIBER_SIGNER_ID, THIRD_PARTY_SIGNER_ID
} from "../Utils/PlanUtils";
import TextInput from "../DataCollection/Inputs/TextInput";
import { handleChange } from "../Utils/DataCollectionUtils";
import DropdownInput from "../DataCollection/Inputs/DropdownInput";
import { apiRequest, saveEnrollment } from "../Utils/APIUtils";
import { generateEnrollmentPackage } from "./EnrollmentPackageGeneration";
import { debugLog } from "../Utils/LogUtils";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useAuthenticationStatus } from "../Authentication/AuthenticationStatusProvider";
import { displayDate, displayDateTime } from "../Utils/FormattingUtils";
import { isLanguageEnglish } from "./PDFGenerationUtils";
import { pdfjs, Document } from 'react-pdf';
import * as pdfjsLib from 'pdfjs-dist';
import Prospectus_En from "./Forms/Prospectus/CET-Prospectus-EN.pdf";
import Prospectus_Fr from "./Forms/Prospectus/CET-Prospectus-FR.pdf";

//We need to set this worker src for pdfjsLib to work correctly
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.js',
    import.meta.url,
).toString();

//This component shows the signing configuration table
// which is a table that shows the status of the signing process for each signer
// and provides the ability to send the package for signing, and to sign the package in person for each signer
// The status column only shows up if the envelope has been submitted
const SigningConfigurationTable = ({
    state,
    signingSetupPhase,
    setSigningSetupPhase,
    envelopeId,
    setEnvelopeId,
    quoteImage,
    quoteImage2
}) => {
    const { t, i18n } = useTranslation()
    const [awaitingServerResponse, setAwaitingServerResponse] = useState(false);
    const [status, setStatus] = useState(''); //This is the status of the signing process

    let { authenticationStatus } = useAuthenticationStatus();

    const signerStatus = (signerId) => {
        console.log("Signer ID: " + signerId);
        return (state.docusign.recipients.find((recipient, index) => {
            return recipient.recipientId === signerId;
        }) || { status: 'Unknown' }).status;
    }
    const signerRecipientType = (signerId) => {
        return (state.docusign.recipients.find((recipient, index) => {
            return recipient.recipientId === signerId;
        }) || { recipientType: 'Unknown' }).recipientType;
    }

    const signerSentDateTime = (signerId) => {
        return (state.docusign.recipients.find((recipient, index) => {
            return recipient.recipientId === signerId;
        }) || { sentDateTime: 'Unknown' }).sentDateTime;
    }

    //This is a sample method that posts the PDF to a backend - intended to demonstrate sending it off to Docusign
    const sendPackageForSignature = () => {

        if (!state.subscriber.inPersonSigner && !state.subscriber.mobilePhone) {
            //TODO: This needs to be done differently
            alert("Subscriber must sign in person or provide a mobile number for remote signing");
            return;
        }

        setAwaitingServerResponse(true);
        setStatus(t('Saving enrolment...'));

        saveEnrollment(state)
            .then(response => {
                setStatus(t('Generating enrolment documents...'));
                generateEnrollmentPackage(state, quoteImage, quoteImage2, authenticationStatus, i18n)
                    .then((enrolmentPackage) => {
                        //fetch("http://localhost:3001/signatures/remote-signing", {
                        //fetch("http://localhost:3001/pdf/signPDFInPerson", {

                        //INJECT PROSPECTUS
                        fetch(isLanguageEnglish(i18n) ? Prospectus_En : Prospectus_Fr)
                            .then(response => response.blob())
                            .then(blob => {

                                console.log(`blob: ${blob}`);

                                new Promise((resolve, reject) => {
                                    const reader = new FileReader();
                                    reader.onloadend = () => {
                                        const base64 = reader.result;
                                        resolve(base64.split(",")[1]);
                                    };
                                    reader.onerror = reject;
                                    reader.readAsDataURL(blob);
                                })
                                    .then(base64 => {

                                        //console.log(`base64: ${base64}`);
                                        //Inject prospectus:
                                        enrolmentPackage.documents.push({
                                            documentId: '999',
                                            name: 'Prospectus',
                                            fileExtension: 'pdf',
                                            pages: [
                                                Prospectus_En
                                            ],
                                            excludedSigners: [
                                                GUARDIAN_SIGNER_ID,
                                                THIRD_PARTY_SIGNER_ID
                                            ],
                                            documentBase64: base64,
                                        });

                                        const guardianSigner = enrolmentPackage.signers.find(s => {
                                            return s.recipientId === GUARDIAN_SIGNER_ID;
                                        })
                                        if (guardianSigner) {
                                            guardianSigner.excludedDocuments.push('999');
                                        }

                                        const thirdPartySigner = enrolmentPackage.signers.find(s => {
                                            return s.recipientId === THIRD_PARTY_SIGNER_ID;
                                        })
                                        if (thirdPartySigner) {
                                            thirdPartySigner.excludedDocuments.push('999');
                                        }

                                        console.log(`enrolmentPackage: ${JSON.stringify(enrolmentPackage)}`);


                                        setStatus(t('Submitting enrolment documents...'));
                                        apiRequest("signatures/submit-envelope", "POST", enrolmentPackage)
                                            .then(data => {
                                                setAwaitingServerResponse(false);
                                                if (data.status === 400) {
                                                    //Some kind of error occurred, probaably on the Docusign end
                                                    const jsonData = JSON.parse(data.response.text);
                                                    throw (new Error(jsonData.message));
                                                    //TODO: Need to do something better than an alert here
                                                }
                                                if (data.errno) {
                                                    if (data.code) {
                                                        throw (new Error(`${data.errno} - ${data.code}`));
                                                    }
                                                }
                                                debugLog(data); // Handle success response
                                                //setBlobURL(data.url);
                                                setEnvelopeId(data.docusign.envelopeId);

                                                //Record the envelope ID in the state
                                                state.setDocusign(data.docusign);
                                                state.setEnrollment({
                                                    ...state.enrollment,
                                                    state: data.state
                                                });

                                                setSigningSetupPhase(false);

                                            }).catch(error => {
                                                setAwaitingServerResponse(false);
                                                console.error('An error occurred:', error);
                                                alert(`An error occurred.  The enrolment was NOT successfully sent for signatures.  ${error}`);
                                            });
                                    });
                            });


                    });
            });


    }

    const signPDFInPerson = (recipientId) => {
        const envelopeId = state.docusign.envelopeId;
        if (!envelopeId) {
            return;
        }

        apiRequest("signatures/recipient-view", "POST", {
            envelopeId: envelopeId,
            recipientId: recipientId
        })
            .then(data => {
                debugLog(data); // Handle success response
                window.open(data.url, '_blank'); //TODO: For now we are loading in another tab... need to figure out the returnURL if this is going to be a solution
                /*
                return; //Returning here to skip Docusign JS which is broken
                window.DocuSign.loadDocuSign(data.integrationKey)
                    .then((docusign) => {
                        console.log("DocuSign loaded");
                        const signing = docusign.signing({
                            url: data.url,
                            displayFormat: 'focused',
                        });

                        signing.on('ready', (event) => {
                            console.log('UI is rendered');
                        });

                        signing.mount('#docusign-agreement');
                    })
                    .catch(error => {
                        console.error('There was a problem with your fetch operation:', error);
                    });
                 */
            })
            .catch(error => {
                console.error('There was a problem with your fetch operation:', error);
            });

    }

    const signerStatusIndicator = (signerId) => {
        return (
            <div>
                {signerStatus(signerId) === 'completed' &&
                    <div>
                        <span className={'material-symbols-outlined'}>check_circle</span>
                        <span>Signing Complete</span>
                    </div>
                }
                {(signerStatus(signerId) === 'sent' || signerStatus(signerId) === 'delivered') && signerRecipientType(signerId) === 'signer' &&
                    <div>
                        <span className={'material-symbols-outlined'}>outgoing_mail</span>
                        <span>E-Mailed for Signing</span>
                        {signerSentDateTime(signerId) &&
                            <div className={'info'}>{displayDateTime(signerSentDateTime(signerId))}</div>
                        }
                    </div>
                }
                {(signerStatus(signerId) === 'sent' || signerStatus(signerId) === 'delivered') && signerRecipientType(signerId) === 'inpersonsigner' &&
                    <div>
                        <span className={'material-symbols-outlined'}>stylus_note</span>
                        <span>Ready to Sign</span>
                        <div>
                            <button onClick={() => {
                                signPDFInPerson(signerId)
                            }}>Sign In Person
                            </button>
                        </div>
                    </div>
                }
                {signerStatus(signerId) === 'autoresponded' &&
                    <div>
                        <span className={'material-symbols-outlined'}>help</span>
                        <span>Verify E-Mail Address</span>
                    </div>
                }
            </div>
        )
    }

    if (awaitingServerResponse || !state.application.prospectusPages) {
        return (
            <div className={'loading-screen'}>
                <div>
                    <div>
                        {status}
                    </div>
                    <div>
                        <img src={'/images/pencil.png'} alt={''} className={'wiggling'} />
                    </div>
                </div>
            </div>
        )
    } else {

        let thirdPartyShouldSign = state.knowYourClient.thirdPartyFinacialSupportForm;
        let custodianShouldSign = !((state.subscriber.primaryCaregiver) || (state.common.subscriber2Include && state.jointSubscriber.primaryCaregiver));

        return (
            <div className={'signing-table-container'}>
                <div>
                    <table className={'signing-table'}>
                        <thead>
                            <tr>
                                <td>Signer</td>
                                <td>Signing Method</td>
                                <td>Authentication Method</td>
                                {state.docusign.envelopeId &&
                                    <td>Status</td>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className={'info'}>Dealing Representative</div>
                                    <div>{state.agent.firstName} {state.agent.lastName}</div>
                                    <div>{state.agent.email}</div>
                                </td>
                                <td>
                                    {t('In Person')}
                                </td>
                                <td>
                                    {t('N/A')}
                                </td>
                                {state.docusign.envelopeId &&
                                    <td>
                                        <div>{signerStatusIndicator(DR_SIGNER_ID)}</div>
                                    </td>
                                }
                            </tr>
                            <tr>
                                <td>
                                    <div className={'info'}>Subscriber</div>
                                    <div>{state.subscriber.firstName} {state.subscriber.lastName}</div>
                                    <div>
                                        <span>{state.subscriber.email}</span>
                                    </div>
                                </td>
                                <td>
                                    <span>{state.subscriber.inPersonSigner ? t('In Person') : t('Remote')}</span>
                                </td>
                                {!state.subscriber.inPersonSigner && !state.knowYourClient.existingSubscriber &&
                                    <td>
                                        {t('Identity document verification')}
                                    </td>
                                }
                                {(state.subscriber.inPersonSigner || (!state.subscriber.inPersonSigner && state.knowYourClient.existingSubscriber)) &&
                                    <td>
                                        +1
                                        <span>{state.subscriber.mobilePhone}</span>
                                        <div className={'info'}>Phone authentication via SMS or phone call</div>
                                    </td>
                                }
                                {state.docusign.envelopeId &&
                                    <td>
                                        <div>{signerStatusIndicator(SUBSCRIBER_SIGNER_ID)}</div>
                                    </td>
                                }
                            </tr>
                            {state.common.subscriber2Include &&
                                <tr>
                                    <td>
                                        <div className={'info'}>{t('Joint Subscriber')}</div>
                                        <div>{state.jointSubscriber.firstName} {state.jointSubscriber.lastName}</div>
                                        <div>{state.jointSubscriber.email}</div>
                                    </td>
                                    <td>
                                        <span>{state.jointSubscriber.inPersonSigner ? t('In Person') : t('Remote')}</span>
                                    </td>
                                    {!state.jointSubscriber.inPersonSigner && !state.knowYourClient.existingSubscriber &&
                                        <td>
                                            {t('Identity document verification')}
                                        </td>
                                    }
                                    {(state.jointSubscriber.inPersonSigner || (!state.jointSubscriber.inPersonSigner && state.knowYourClient.existingSubscriber)) &&
                                        <td>
                                            +1
                                            <span>{state.jointSubscriber.mobilePhone}</span>
                                            <div className={'info'}>Phone authentication via SMS or phone call</div>
                                        </td>
                                    }
                                    {state.docusign.envelopeId &&
                                        <td>{signerStatusIndicator(JOINT_SUBSCRIBER_SIGNER_ID)}</td>
                                    }
                                </tr>
                            }

                            {beneficiaryShouldSign(state) &&
                                <tr>
                                    <td>
                                        <div className={'info'}>{t('Beneficiary')}</div>
                                        <div>{state.beneficiary.firstName} {state.beneficiary.lastName}</div>
                                        <div>{state.beneficiary.email}</div>
                                    </td>
                                    <td>
                                        <span>{state.beneficiary.inPersonSigner ? t('In Person') : t('Remote')}</span>
                                    </td>

                                    {!state.beneficiary.inPersonSigner && !state.knowYourClient.existingSubscriber &&
                                        <td>
                                            {t('Identity document verification')}
                                        </td>
                                    }
                                    {(state.beneficiary.inPersonSigner || (!state.beneficiary.inPersonSigner && state.knowYourClient.existingSubscriber)) &&
                                        <td>
                                            +1
                                            <span>{state.beneficiary.mobilePhone}</span>
                                            <div className={'info'}>Phone authentication via SMS or phone call</div>
                                        </td>
                                    }

                                    {state.docusign.envelopeId &&
                                        <td>{signerStatusIndicator(BENEFICIARY_SIGNER_ID)}</td>
                                    }
                                </tr>
                            }

                            {thirdPartyShouldSign &&
                                <tr>
                                    <td>
                                        <div className={'info'}>{t('Third Party')}</div>
                                        <div>{state.knowYourClient.thirdPartyName}</div>
                                        <div>{state.knowYourClient.thirdPartyEmail}</div>
                                    </td>
                                    <td>
                                        <span>{state.knowYourClient.thirdPartyInPersonSigner ? t('In Person') : t('Remote')}</span>
                                    </td>
                                    {!state.knowYourClient.thirdPartyInPersonSigner &&
                                        <td>
                                            {t('Identity document verification')}
                                        </td>
                                    }
                                    {state.knowYourClient.thirdPartyInPersonSigner &&
                                        <td>
                                            +1
                                            <span>{state.knowYourClient.thirdPartyPhone}</span>
                                            <div className={'info'}>Phone authentication via SMS or phone call</div>
                                        </td>
                                    }
                                    {state.docusign.envelopeId &&
                                        <td>{signerStatusIndicator(THIRD_PARTY_SIGNER_ID)}</td>
                                    }
                                </tr>
                            }

                            {custodianShouldSign &&
                                <tr>
                                    <td>
                                        <div className={'info'}>{t('Guardian')}</div>
                                        <div>{state.application.custodianFirstName} {state.application.custodianLastName}</div>
                                        <div>{state.application.custodianEmail}</div>
                                    </td>
                                    <td>
                                        <span>{state.application.custodianInPersonSigner ? t('In Person') : t('Remote')}</span>
                                    </td>
                                    {!state.application.custodianInPersonSigner &&
                                        <td>
                                            {t('Identity document verification')}
                                        </td>
                                    }
                                    {state.application.custodianInPersonSigner &&
                                        <td>
                                            +1
                                            <span>{state.application.custodianMobilePhone}</span>
                                            <div className={'info'}>Phone authentication via SMS or phone call</div>
                                        </td>
                                    }

                                    {state.docusign.envelopeId &&
                                        <td>{signerStatusIndicator(GUARDIAN_SIGNER_ID)}</td>
                                    }
                                </tr>
                            }
                        </tbody>
                    </table>
                    {state.application.childApplicationIds && state.application.childApplicationIds.length > 0 &&
                        <div className={'family-enrolment-warning'}>
                            <div>
                                <span
                                    data-tooltip-content={t('Family Enrolment')}
                                    data-tooltip-id={'tooltip'}
                                >
                                    <span className="material-symbols-outlined">
                                        diversity_3
                                    </span>
                                </span>
                                {t('This is the primary enrolment of a Family Enrolment.')}
                            </div>
                            {state.application.childApplicationIds.length > 1 &&
                                <div>{t(`There are ${state.application.childApplicationIds.length} secondary enrolments that are part of this Family Enrolment.`)}</div>
                            }
                            {state.application.childApplicationIds.length === 1 &&
                                <div>{t(`There is ${state.application.childApplicationIds.length} secondary enrolment that is part of this Family Enrolment.`)}</div>
                            }
                            <div>{t(`Know Your Client and Subscriber details cannot be changed in secondary enrolments once the primary package is Sealed and Sent for Signatures.`)}</div>
                            <div></div>
                        </div>
                    }


                    <div className={'signing-table-footer'}>
                        {!state.docusign.envelopeId && signingSetupPhase &&
                            <span>
                                <button
                                    onClick={sendPackageForSignature}>{t('Seal Package and Send for Signatures')}</button>
                                <button onClick={() => {
                                    setSigningSetupPhase(false)
                                }}>{t('Cancel')}</button>
                            </span>
                        }
                    </div>
                </div>

            </div>
        )
    }
}

export default SigningConfigurationTable;